import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { LOCATION_MISMATCH_BAR } from '@yme/components/Header/LocationMismatchBar/constants';
import { getHeaderStickyMenuShown, getLocationMismatchBarOpen, } from '@yme/components/Header/redux/selectors';
import { useMenuHeight } from './useMenuHeight';
export function useHeaderHeight() {
    const [locationMismatchBarHeight, setLocationMismatchBarHeight] = useState(0);
    const menuHeight = useMenuHeight();
    const isLocationMismatchBarOpen = useSelector(getLocationMismatchBarOpen);
    const isHeaderStickyMenuShown = useSelector(getHeaderStickyMenuShown);
    useEffect(() => {
        if (isLocationMismatchBarOpen) {
            const locationMismatchBar = document.getElementById(LOCATION_MISMATCH_BAR);
            setLocationMismatchBarHeight(locationMismatchBar ? Math.floor(locationMismatchBar.getBoundingClientRect().height) : 0);
        }
    }, [isLocationMismatchBarOpen]);
    if (isHeaderStickyMenuShown) {
        return menuHeight;
    }
    return isLocationMismatchBarOpen ? menuHeight + locationMismatchBarHeight : menuHeight;
}
